import { createApi } from '@reduxjs/toolkit/query/react';
import deserialize from 'helpers/getroPropertyMapper';

import { networkBaseQueryV2 } from './queries';

export const apiKeysApiV2 = createApi({
  reducerPath: 'apiKeysApiV2',
  baseQuery: networkBaseQueryV2,
  tagTypes: ['api-keys'],
  endpoints: (builder) => ({
    getApiKeys: builder.query({
      query: () => ({
        url: `/api_keys`,
      }),
      transformResponse: (response) => deserialize(response),
      providesTags: ['api-keys'],
    }),
    createApiKey: builder.mutation({
      query: ({ label }) => ({
        url: `/api_keys`,
        method: 'POST',
        data: { label },
      }),
      transformResponse: (response) => deserialize(response),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            apiKeysApiV2.util.updateQueryData('getApiKeys', undefined, (draft) => {
              draft.unshift(data);
            }),
          );
        } catch {
          // Do nothing
        }
      },
    }),
    revokeApiKey: builder.mutation({
      query: ({ id }) => ({
        url: `/api_keys/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          apiKeysApiV2.util.updateQueryData('getApiKeys', undefined, (draft) => {
            const index = draft.findIndex((key) => key.id === id);
            if (index !== -1) {
              draft.splice(index, 1);
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const { useGetApiKeysQuery, useCreateApiKeyMutation, useRevokeApiKeyMutation } = apiKeysApiV2;
